export default "__VITE_ASSET__BAhg_MHw__"